import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import Layout from './Layout.js';
import Formwizard from '../../../wizard/index.js';
import Footer from './Footer.js';
import CustomNavigationButtons from './CustomNavigationButtons.js';
import UserDataStep from './UserDataStep.js';
import { jsx } from '@emotion/react';
var Raffle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Layout, {
    ref: ref
  }, jsx(Formwizard, _extends({
    components: {
      UserDataStep: UserDataStep,
      CustomNavigationButtons: CustomNavigationButtons
    }
  }, props)), jsx(Footer, {
    mt: 3
    // Compensate Layout padding of 8 so the grayed Footer reaches left and right end.
    ,

    mx: -8
  }));
});
export { Raffle as default };